"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BasicStorage = /** @class */ (function () {
    function BasicStorage() {
        this.storage = {};
    }
    BasicStorage.prototype.clear = function () {
        this.storage = {};
    };
    BasicStorage.prototype.getItem = function (key) {
        return this.storage[key];
    };
    BasicStorage.prototype.removeItem = function (key) {
        // tslint:disable-next-line:no-dynamic-delete
        delete this.storage[key];
    };
    BasicStorage.prototype.setItem = function (key, value) {
        this.storage[key] = value;
    };
    return BasicStorage;
}());
exports.BasicStorage = BasicStorage;
//# sourceMappingURL=BasicStorage.js.map